'use strict';

var processInclude = require('base/util');

processInclude(require('./video'));
processInclude(require('./hero'));
processInclude(require('./hotspot'));
processInclude(require('./header'));
processInclude(require('./brands'));
processInclude(require('./navigationBar'));
processInclude(require('./einsteinCarousel'));